<div class="mb-3">
  <div class="row row-cols-auto justify-content-between">
    <div>
      @if (isPrintMode() && showBackBtn()) {
        <app-btn text="Back to Normal View" icon="previous" (mclick)="setAsViewMode()" />
      }
    </div>
    <div>
      @if (!isPrintMode()) {
        <app-btn [text]="btnText" icon="export" [disabled]="disableExport()" (mclick)="setAsPrintMode()" />
      }
    </div>
  </div>
</div>
@if (isPrintMode()) {
  <div class="">
    <ng-container *ngTemplateOutlet="printContent"></ng-container>
  </div>
} @else {
  <ng-template [ngTemplateOutlet]="actualContent"></ng-template>
}
